import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="site-faq" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-4xl px-4 py-10 md:px-8 md:py-14">
        <div className="text-center">
          <h2 className="font-heading text-2xl tracking-wide text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">关于爆料专区，你可能想知道的几件事。</p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-900 md:text-base">{faq.q}</span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}